import { createSlice } from "@reduxjs/toolkit";
import { fetchCommunityDocName } from "../CommunityAPI/communityApi";

const communityDocNameSlice = createSlice({
  name: "communityDocName",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunityDocName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityDocName.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityDocName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default communityDocNameSlice.reducer;
